import { StyleSheet, type TextStyle } from 'react-native';

export const FONT_FAMILY =
    'gitbook-content-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';
export const CODE_FONT_FAMILY = 'gitbook-code-font, Menlo, monospace';

export const FONT_SIZES = {
    xxlarge: 40,
    xlarge: 32,
    large: 24,
    mediumLarge: 20,
    medium: 16,
    small: 14,
    xsmall: 12,
    xxsmall: 10,
} as const;

export const LINE_HEIGHTS = {
    xxlarge: 48,
    xlarge: 40,
    large: 32,
    mediumLarge: 30,
    medium: 24,
    small: 22,
    xsmall: 18,
    xxsmall: 14,
} as const;

export const FONT_WEIGHTS = {
    bold: '700',
    semiBold: '600',
    medium: '500',
    // Fix types error, '360' is not accepted by React Native
    regular: '360' as 'normal',
} as const;

export const typography = {
    // @ts-ignore - FONT_WEIGHTS.regular, Spine Content Paragraph
    Body: {
        fontFamily: FONT_FAMILY,
        fontSize: FONT_SIZES.medium,
        lineHeight: LINE_HEIGHTS.medium,
        fontWeight:
            '360' /* Favorit is variable and renders nicely at 360. Relying on the other font-families only loading 400 as lowest font-weight. */,
    } as TextStyle,

    // Spine: UI Action
    Label: {
        fontFamily: FONT_FAMILY,
        fontSize: FONT_SIZES.small,
        lineHeight: LINE_HEIGHTS.small,
        fontWeight: FONT_WEIGHTS.regular,
    } as TextStyle,

    // Spine: UI Small
    Caption: {
        fontFamily: FONT_FAMILY,
        fontSize: FONT_SIZES.xsmall,
        lineHeight: LINE_HEIGHTS.xsmall,
        fontWeight: FONT_WEIGHTS.regular,
    } as TextStyle,

    MobileCaption: {
        fontFamily: FONT_FAMILY,
        fontSize: FONT_SIZES.xxsmall,
        lineHeight: LINE_HEIGHTS.xxsmall,
        fontWeight: FONT_WEIGHTS.regular,
    } as TextStyle,

    Code: {
        fontFamily: CODE_FONT_FAMILY,
        fontSize: FONT_SIZES.small,
        lineHeight: LINE_HEIGHTS.small,
        fontWeight: FONT_WEIGHTS.medium,
    } as TextStyle,
} as const;

export const textStyles = {
    Bold: {
        fontWeight: FONT_WEIGHTS.bold,
    },
    SemiBold: {
        fontWeight: FONT_WEIGHTS.semiBold,
    },
    Medium: {
        fontWeight: FONT_WEIGHTS.medium,
    },
    Italic: {
        fontStyle: 'italic',
    },
    Underline: {
        textDecorationLine: 'underline',
    },
    Strikethrough: {
        textDecorationLine: 'line-through',
    },
    AlignCenter: {
        textAlign: 'center',
    },
    AlignRight: {
        textAlign: 'right',
    },
    Uppercase: {
        textTransform: 'uppercase',
    },
    /**
     * For web only, use this style to indicate that the text can be highlighted and selected.
     * It should be used with the `selectable` prop of <Text>
     */
    Selectable: {
        cursor: 'text',
    } as TextStyle,
} as const;

export const font = StyleSheet.create({
    ...typography,
    ...textStyles,
});
